import React from "react";

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import { checkTranslation, pathMaker, translate } from "../../utils/useful";
import Cookies from "universal-cookie";
import Modal from "../../components/Modal";


class ActiveSessions extends React.Component {

    state = {
        modules: [],
        collapses: {},
        pages: [],
        actives: [
            { img: '/images/p2.png', name: 'iphone 12 Pro Max', des: 'Yonnect iOS 2.3.0', location: 'Miami United State', time: '9:26 AM' },
            { img: '/images/p3.png', name: 'iphone 13 Pro', des: 'Yonnect iOS 2.2.0', location: 'Miami United State', time: '8:46 AM' },
        ],

        period: [
            { duration: '1 Week' },
            { duration: '1 Month' },
            { duration: '2 Month' },
            { duration: '3 Month' },
            { duration: '6 Month' },
            { duration: '1 Year' },
        ]
    }


    componentDidMount() {
        this.setState({ isLoading: false }, () => {
            this.setState({ pageStatus: 200 })

        })

        return

        // const cookies = new Cookies();
        // let token = cookies.get('token');
        // if (token) {
        //     this.setState({ isLoading: true })
        //     this.waitForId(10)
        // } else {
        //     this.setState({ pageStatus: 401 })
        // }
    }


    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {
            this.setState({ isLoading: false }, () => {
            })
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }

    changePage = (page) => {

        let path = pathMaker('/admin/' + page)

        this.props.history.push(path)

        if (this.mobileMenuModal) {
            this.mobileMenuModal.hideModal()
        }

    }


    setUser = (data) => {
        this.props.actions.setUser(data, null, true)
    }


    addNotif = (options) => {
        this.props.actions.addNotif(options)
    }

    changeCollapse = (key) => {
        let collapses = this.state.collapses
        collapses[key] = this.state.collapses[key] == null ? true : !this.state.collapses[key]
        this.setState({ collapses })
    }

    openInactiveModals = () => {
        this.InactiveModal.showModal()
    }

    openTerminateModal = () => {
        this.TerminateModal.showModal()
    }
    setData = (key, value, reference, cb) => {
        if (reference == 'CommingSoon') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {

                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }


    render() {
        return (
            <div className="flexcc w-100 h-100 sc-gray2 pt-5" style={{overflow:'auto', backgroundColor: '#f5f5f5' }}>
                <div className=" w-100" style={{ maxWidth: '900px' }}>
                    <div className="w-100 ">
                        <div className="" style={{ borderBottom: '1px solid #ddd' }}>
                            <div className="flexcb w-100 py-2 px-3 mt-2">
                                <p className="font-size-16 main-c4 weight-500">This Device</p>
                                <button className="flexc hover-red br-10 p-2">
                                    <img width={22} src="/assets/icons/applets/hand-red.svg" />
                                    <p style={{ color: '#FF3B30' }}>Terminate all sessions</p>
                                </button>
                            </div>
                            <button className=" flexc w-100 hover-setting px-3 pt-2 pb-3">
                                <img className="br-50" width={60} src="/images/p1.png" />
                                <div className="mld-3 flexcb w-100 ">
                                    <div className="text-start">
                                        <p className="font-size-14 main-c2 weight-500">Razer Blade 15 Advance</p>
                                        <p className="font-size-12 main-c5">Yonnect Desktop 4.8.1 x64 Microsoft Store</p>
                                        <p className="font-size-12 main-c7">Miami, United States</p>
                                    </div>
                                    <button className="flexcc hub-setting-btn py-2 pld-2 prd-4 br-10" style={{ width: '100px' }}>
                                        <img className="flexcc " width={22} src="/assets/icons/applets/rename-gray.svg" />
                                        <p className="mld-2">Rename</p>
                                    </button>
                                </div>
                            </button>
                        </div>

                        <p className="p-3 font-size-16 main-c4 weight-500">Active Sessions</p>
                        <div className="" style={{ borderBottom: '1px solid #ddd' }}>
                            {this.state.actives.map((prop, index) => {
                                return (
                                    <div className=" flexcb w-100 hover-setting px-3 py-3">
                                        <div className="flexc ">
                                            <img className="br-50" width={60} src={prop.img} />
                                            <div className="text-start mld-3">
                                                <p className="font-size-14 main-c2 weight-500">{prop.name}</p>
                                                <p className="font-size-12 main-c5">{prop.des}</p>
                                                <p className="font-size-12 main-c7">{prop.location}<span className="mld-2">{prop.time}</span></p>
                                            </div>
                                        </div>
                                        <button className="flexc hub-setting-btn py-2 pld-2 prd-4 br-10" style={{ width: '100px' }} onClick={() => this.openTerminateModal()}>
                                            <img className="flexcc" width={22} src="/assets/icons/cross-gray.svg" />
                                            <p className="">Terminate</p>
                                        </button>
                                    </div>
                                )
                            })}
                        </div>
                        <div className="flexcb w-100 p-3">
                            <p className="p-3 font-size-16 main-c4 weight-500">Terminate old Sessions</p>
                            <div className="flexc">
                                <p className="mrd-4 main-c6">If inactive for...</p>
                                <button className="hub-setting-btn px-3 py-2 br-10" style={{ width: '100px' }} onClick={() => this.openInactiveModals()}>
                                    <p className="font-size-14">6 Month</p>
                                </button>
                            </div>
                        </div>
                        <div className="p-4 mx-3 mb-3 br-10" style={{ backgroundColor: '#ECEAF0' }}>
                            <p className="main-c7 font-size-10">The Official Yonnect app is available for Android, iPhone, iPad, Windows, macOS and also the web Application is available.</p>
                        </div>
                    </div >
                    <Modal maxWidth={250} ref={el => this.InactiveModal = el}>
                        <div className="bg-white w-100 h-100 br-20 p-3">
                            <p className="main-c4 weight-500 font-size-16">Session Termination</p>
                            <p className="main-c7 font-size-12">If you don't come online from a specific session at least once within this period, it will be terminated.</p>
                            <div className="d-flex flex-column mt-3">
                                {this.state.period.map((prop, index) => {
                                    return (
                                        <button class="text-start flexc mb-3">
                                            <div class="box">
                                                <input type="checkbox" class="checkbox-input" id="checkbox" />
                                                <label for="checkbox">
                                                    <span class="checkbox">
                                                    </span>
                                                </label>
                                            </div>
                                            <p className="mld-3 font-size-14 main-c4 weight-400">{prop.duration}</p>
                                        </button>
                                    )
                                })}
                            </div>
                        </div>
                    </Modal>
                    <Modal maxWidth={400} hight={'100%'} ref={el => this.TerminateModal = el}>
                        <div className="bg-white w-100 br-20 p-3">
                            <p className="main-c4 weight-500 font-size-16">Session Termination</p>
                            <p className="main-c7 weight-500 font-size-12">Are you sure you want to Terminate this session?</p>
                            <div className="flexcb mt-5">
                                <button className="red-box-fill w-100 mrd-2 br-10 py-2">
                                    <p className="font-size-14">Terminait</p>
                                </button>
                                <button className='gray-btn w-100 mld-2 br-10 py-2'>
                                    <p className="font-size-14">Cancel</p>
                                </button>
                            </div>
                        </div>
                    </Modal>
                </div >
            </div >
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ActiveSessions);
